import React from 'react';
import {useTranslation} from 'react-i18next';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';

/**
 * «¿Aplicar la plantilla?» — sólo cuando la hoja tiene algún bloque de texto ESCRITO (card
 * 1YGcVgVw). Aplicar una plantilla reemplaza todos los bloques, y un gráfico se vuelve a armar en
 * dos clics, pero los insights que escribió la agencia no: sin esta pregunta se iban sin aviso.
 * Sin textos escritos, la plantilla se aplica directo, como siempre.
 */
export function ApplyTemplateConfirmModal({isOpen, templateName, onConfirm, onCancel}) {
    const {t} = useTranslation();
    return (
        <Modal isOpen={isOpen} toggle={onCancel} className="inf-unsaved-modal" data-testid="apply-template-confirm">
            <ModalHeader toggle={onCancel}>
                {templateName
                    ? t('informes.template.apply_confirm.title_named', {name: templateName, interpolation: {escapeValue: false},
                        defaultValue: '¿Aplicar la plantilla «{{name}}»?'})
                    : t('informes.template.apply_confirm.title', '¿Aplicar la plantilla?')}
            </ModalHeader>
            <ModalBody>
                <div className="modal-section">
                    <p>{t('informes.template.apply_confirm.text',
                        'La plantilla reemplaza todos los bloques del informe, también los textos que escribiste. Si no guardas, puedes volver atrás.')}</p>
                </div>
            </ModalBody>
            {/* Como M7: «Cancelar» en contorno a la izquierda y la acción que se viene a hacer,
                rellena, a la derecha (QA-VIS-texto-06). No se pierde nada sin guardar. */}
            <ModalFooter>
                <button type="button" className="btn -alt -negative" onClick={onCancel} data-testid="apply-template-cancel">
                    {t('common.cancel', 'Cancelar')}
                </button>
                <button type="button" className="btn -alt" onClick={onConfirm} data-testid="apply-template-go">
                    {t('informes.template.apply_confirm.apply', 'Aplicar plantilla')}
                </button>
            </ModalFooter>
        </Modal>
    );
}
